import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'

export default boot(async ({ store, Vue }) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    trackComponents: true,
    beforeSend(event) {
      event.tags = event.tags || {}
      event.tags.piva = store.state.tenant.piva

      const { user } = store.state.auth
      if (user) {
        event.tags.company = user.company.RagioneSociale
        event.user = {
          id: user.value,
          username: user.label,
        }
      }

      return event
    },
  })
})
